<template>
    <div>
        <DefaultCard :title="$t('referral.info')"
                     :is-busy="isBusy"
                     :error="error">
            <div class="mb-3 user-details">
                <InputField :label="$t('referral.referredBy')"
                            :value="referralInfo.referredBy"
                            :readOnly="true"/>
                <InputField :label="$t('referral.referees')"
                            :value="referralInfo.referees"
                            :readOnly="true"/>

                <div class="mb-4 mt-4">
                    {{ $t("referral.receivedReferralBonus") }}
                    <span :class="referralInfo.receivedReferralBonus ? 'active' : 'inactive'"></span>
                </div>

                <InputField :label="$t('referral.reason')"
                            :value="referralInfo.failureReason"
                            :readOnly="true"/>
            </div>

            <TDSButton button-style="primary-red" style="margin-right: 6px;" @click="manualProcess">{{ $t('referral.manualProcess') }}</TDSButton>

        </DefaultCard>
    </div>
</template>

<script lang="ts">
import {VueClassTemplate} from "@/util/VueClassTemplate";
import DefaultCard from "@/components/partials/DefaultCard.vue";
import {Component, Watch} from "vue-property-decorator";
import DefaultLayout from "@/components/layouts/DefaultLayout.vue";
import TDSError from "@/components/common/TDSError.vue";
import TDSSpinner from "@/components/common/TDSSpinner.vue";
import InputField from "@/components/common/InputField.vue";
import TDSButton from "@/components/common/TDSButton.vue";
import {ReferralInfo} from "@/interfaces/entities/ReferralInfo";
import TDSCheckbox from "@/components/common/TDSCheckbox.vue";

@Component({
    components: {
        DefaultLayout, TDSError, TDSSpinner, InputField, DefaultCard, TDSButton, TDSCheckbox
    }
})

export default class Referral extends VueClassTemplate {
    private userId: string = this.$route.params.userId;
    private referralInfo: ReferralInfo | null = null;
    private customInput: string = "";
    private inputError: string = "";

    @Watch("error")
    errorChanged() {
        console.log("error changed: ", this.error);
    }

    async init() {
        this.startProgress("loading");
        await this.loadReferralInfo();
        this.endProgress("loading");
    }

    async loadReferralInfo() {
        try {
            this.referralInfo = await this.$store.dispatch("FETCH_REFERRAL_INFO", this.userId);
        } catch (e) {
            this.error = this.$t("general.error.loading", [e.message]) + "";
        }
    }

    async manualProcess() {
        try {
            await this.$store.dispatch("MANUAL_REFERRAL_PROCESS", this.userId);
            this.$toastr.success("Successfully processed ", undefined, false);
        } catch (e) {
            this.error = ("Error while sending request: " + e.message);
        } finally {
            await this.loadReferralInfo();
        }
    }

}
</script>
<style lang="scss" scoped>
.inactive {
    background: transparent url('../../assets/icons/close-circle-dent-red.svg') no-repeat center;
    background-size: 12px auto;
    height: 12px;
    width: 12px;
    display: block;
    margin-right: 4px;
}

.active {
    background: transparent url('../../assets/icons/check-circle-green.svg') no-repeat center;
    height: 12px;
    width: 12px;
    background-size: 12px;
    display: block;
    margin-right: 4px;

}
</style>
